import { useState } from "react";
import { laptopNav } from "helpers/constants";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Bell, SignOut, User } from "@phosphor-icons/react";
import WideModalsWrapper from "components/Modals/ModalsWrapper/WideModalWrapper";
import LogoutModal from "./LogoutModal";
import PageHeader from "./PageHeader";
const tabs = [...laptopNav];

function DesktopWrapper({ children }) {
  const user = useSelector((state) => state.user.user);
  const history = useHistory();
  const [logOut, setLogOut] = useState(false);

  const onLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("navList");
    localStorage.removeItem("selectedTab");
    window.location.href = window.location.origin + "/";
  };
  return (
    <>
      <WideModalsWrapper
        isOpen={logOut}
        closeModal={() => {
          setLogOut(false);
        }}
        component={<LogoutModal onLogout={onLogout} />}
      />

      <div className="w-screen h-screen lg:flex flex-row items-stretch hidden">
        <div className="side-nav py-5 h-full w-full flex flex-col justify-between">
          <div className="flex flex-col space-y-7 items-center">
            <div className="flex flex-row items-center justify-between w-full px-5">
              <a href="/">
                <div className="flex flex-row items-center space-x-2.5">
                  <img
                    src="/assets/caaryaLogos/pmoLogo.png"
                    className="h-6 w-6 object-fill"
                    alt="logo"
                  />
                  <h1 className="font-bold font-karla text-sm text-primary-yellow-darkest">
                    PMO
                  </h1>
                </div>
              </a>
              <div className="flex gap-2 items-center">
                <User size={14} />
                <Bell size={14} />
              </div>
            </div>
            <div className="px-5 flex items-start space-y-1.5 w-full justify-between">
              <div className="flex flex-col items-start w-full">
                <h2 className="font-lato text-xs">Hello,</h2>
                <h1 className="text-xl font-lato">{user?.first_name}</h1>
              </div>
            </div>
            <div className="flex flex-col items-start w-full pl-2.5 space-y-2">
              {tabs?.map((item, idx) => {
                return (
                  <div
                    key={idx}
                    onClick={() => {
                      history.push(item?.path);
                    }}
                    className={`w-full cursor-pointer flex flex-row items-center space-x-4 menuitem ${
                      window.location.pathname.includes(item?.path)
                        ? "active"
                        : ""
                    }`}
                  >
                    {item?.image ? (
                      <img
                        src={
                          window.location.pathname.includes(item?.path)
                            ? item?.selectedImage
                            : item?.image
                        }
                        alt=""
                        className="w-6 h-6"
                      />
                    ) : (
                      item?.icon
                    )}
                    <p className="">{item?.name}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="pl-2.5 mt-auto mx-auto w-full flex flex-row items-center justify-between cursor-pointer">
            <div
              className={`w-full cursor-pointer px-2 flex flex-row items-center space-x-5 py-3 menuitem`}
              onClick={() => {
                setLogOut(true);
              }}
            >
              <SignOut size={25} />
              <p className="ml-1.5 font-normal text-[#565E6C]">Logout</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col w-full">
          <PageHeader />
          <div className="flex flex-col items-stretch w-[80vw] mx-auto max-w-[1380px] px-5.5 pt-5">
            {children}
          </div>
        </div>
      </div>
    </>
  );
}

export default DesktopWrapper;
